module.exports = __webpack_public_path__ + "static/media/repeat-deposit.c1cb96d3.svg";